import { TEMPLATE_ROUTE_PREFIXES } from "../constants/template";
import { FeedTemplateType, TemplateType } from "../types/template";

export const normalizeTemplateType = (
  value: string | null | undefined
): TemplateType | null => {
  const normalized = String(value || "").toUpperCase();

  if (normalized === "DISCOVER") return "DISCOVER";
  if (normalized === "POST") return "POST";
  if (normalized === "VERTICAL_VIDEO") return "VERTICAL_VIDEO";

  return null;
};

export const normalizeFeedTemplateType = (
  value: string | null | undefined
): FeedTemplateType | null => {
  const templateType = normalizeTemplateType(value);
  if (templateType === "POST" || templateType === "VERTICAL_VIDEO") {
    return templateType;
  }
  return null;
};

export const getTemplateTypeFromRouteContext = (
  pathname: string,
  feedTemplateType: FeedTemplateType
): TemplateType | null => {
  if (pathname.startsWith("/feed")) {
    return feedTemplateType;
  }

  const orderedTemplateTypes: TemplateType[] = [
    "POST",
    "VERTICAL_VIDEO",
    "DISCOVER",
  ];

  for (const templateType of orderedTemplateTypes) {
    const isMatched = TEMPLATE_ROUTE_PREFIXES[templateType].some((prefix) =>
      pathname.startsWith(prefix)
    );

    if (isMatched) {
      return templateType;
    }
  }

  return null;
};
